import React, { SVGProps } from "react";
import { useEnigmaToken } from "@hooks/useEnigmaToken";

export const TableEmptyIcon = (props: SVGProps<SVGSVGElement>) => {
    const token = useEnigmaToken();
    return (
        <svg
            {...props}
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="4"
                y="4"
                width="48"
                height="48"
                rx="24"
                fill={token.color.core.primary}
                opacity={0.2}
            />
            <path
                d="M37 37L33.5001 33.5M36 27.5C36 32.1944 32.1944 36 27.5 36C22.8056 36 19 32.1944 19 27.5C19 22.8056 22.8056 19 27.5 19C32.1944 19 36 22.8056 36 27.5Z"
                stroke={token.color.core.primary}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
